import React, {useState, useEffect} from 'react';
import MobileEntityList from './MobileEntityList';
import MobileEntityView from './MobileEntityView';
import {getEntities, checkStatus} from 'utils/api/entitiesApi';
import './style.scss';

const MobileEntities = () => {
    const [activeView, setActiveView] = useState('entityList');
    const [entitiesLoading, setEntitiesLoading] = useState(true);
    const [fullEntitiesList, setFullEntitiesList] = useState([]);

    useEffect(() => {
        fetchEntities();
    }, []);

    const fetchEntities = async() => {
        try {
            !entitiesLoading && setEntitiesLoading(true);
            let entitiesData = await getEntities();
            console.log(entitiesData);
            console.log(entitiesData.content.result)
            setFullEntitiesList(entitiesData.content.result)
            setEntitiesLoading(false);
        } catch(err) {
            // handleErrors(err);
            setEntitiesLoading(false);
        }
    };

    const handleEntityView = () => {
        switch(activeView) {
            case 'entityList':
                return (
                    <MobileEntityList
                        fullEntitiesList={fullEntitiesList}
                        entitiesLoading={entitiesLoading}
                    />
                )
            case 'entityView':
                return <MobileEntityView/>;
            default:
                return <MobileEntityList/>;
        }
    };

    return (
        <div className="mobile-view">
            <>
                {handleEntityView()}
            </>
        </div>
    );
};

export default MobileEntities;
